import { pdf } from '@react-pdf/renderer';
import { useDispatch, useSelector, useStore } from "react-redux";
import { useContext, useEffect, useState } from 'react';
import Button from "components/molecules/Button";
import ExportDocument from "components/templates/ExportDocument";
import ReducersIndex from "reduxModules/ducks";
import { getCurrentValue, getRecalculate, getRemap } from "reduxModules/ducks/container";
import { buttonThemes } from "globalConstants/Themes";
import ToolContext from 'components/services/ToolContext';
import { has, isEmpty, values } from 'lodash';


const Export = (props) => {
  const dispatch = useDispatch();
  const store = useStore();
  const context = useContext(ToolContext);
  const report = context.reportDocument;
  const constants = context.constants;
  const { tool: { landingMenu, localCalc }, defaultPlots } = constants;
  const tab = useSelector(state => state.ui.tabs[0].id);

  const recalculate = useSelector(getRecalculate);
  const remap = useSelector(getRemap);
  const saved = useSelector(state => getCurrentValue(state, 'savekey'))
  const rev = useSelector(state => getCurrentValue(state, 'revision'))
  const needsResave = useSelector(state => getCurrentValue(state, 'needsResave'))
  const [exportReady, setExportReady] = useState(false);
  const [resave, setResave] = useState(false);

  const [isFirstSave, setIsFirstSave] = useState(false);

  const areas = useSelector(state => values(state.container.areas))

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const processAreas = async (areas) => {
    for (const area of areas) {
      const areaDevices = ['microphones', 'speakers'];
      if (area.cameras.hasCamera) areaDevices.push(('cameras'));
      const needsPlotData = areaDevices
        .filter(device => has(area[device], 'plotData') ? isEmpty(area[device].plotData) : true);
      if (needsPlotData.length > 0) {
        dispatch(ReducersIndex.uiReducers.setActiveTab(area.id));
        dispatch(ReducersIndex.uiReducers.setCurrentView(landingMenu));
        // Wait for plotData to be populated
        while (true) {
          const currentArea = store.getState().container.areas[area.id];
          const stillNeedsPlotData = areaDevices.some(device =>
            has(currentArea[device], 'plotData') ? isEmpty(currentArea[device].plotData) : true);

          if (!stillNeedsPlotData) break;
          await delay(100);
        };
      };
    };
  };


  useEffect(() => {
    const handleExport = async () => {
      if (exportReady) {
        if (localCalc) {
          dispatch(ReducersIndex.uiReducers.openModal('exporting'));
          await processAreas(areas)
        } else {
          dispatch(ReducersIndex.uiReducers.setActiveTab(tab));
          dispatch(ReducersIndex.uiReducers.setCurrentView(landingMenu));
          dispatch(ReducersIndex.uiReducers.setShowMap(defaultPlots[landingMenu]));
        };
        if (!saved) { // This works for new projects 
          props.setSilentSave(true);
          setIsFirstSave(true);
          // todo: add a check for CRD 
        } else if (recalculate || remap ) {  // this only works if I'm not in a device view. in device view the calculation is done so both flags are cleared and the new version is not saved 
          setResave(true);
        } else {
          if (isFirstSave || resave || needsResave) {
            props.setSilentSave(true);
            while (true) {
              const newRev = store.getState().ui.revision;
              if (isFirstSave) {
                setIsFirstSave(false)
                break;
              };
              if (newRev !== rev) break;
              await delay(100);
            };
            setResave(false);
          }
          setTimeout(openPdf, 100);
        };
      };
    };
    handleExport();
    // eslint-disable-next-line
  }, [recalculate, remap, exportReady, saved]);


  const openPdf = async () => {
    dispatch(ReducersIndex.uiReducers.openModal('exporting'));
    const blob = await pdf(<ExportDocument report={report} store={store} />).toBlob();
    const pdfURL = URL.createObjectURL(blob);
    const newWin = window.open(pdfURL, '_blank');
    if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
      alert('The export document was blocked by your browser.\nPlease allow pop-ups from this page')
    }
    setExportReady(false)
    dispatch(ReducersIndex.uiReducers.closeModal('exporting'));
  };

  return (
    <Button id={'exportButton'} theme={buttonThemes.nav_red} label={"EXPORT"} onClick={() => setExportReady(true)} />
  )
};

export default Export;